window.handleClickOnCode = (event) =>
{
    navigator.clipboard.writeText(event.target.innerText);
    Swal.fire({
        title: 'Code copié !',
        text: event.target.innerText,
        toast: true,
        timer: 1500,
        showConfirmButton: false,
        position: 'top-end',
        icon: 'success',
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })
}